import type { BadgeTone } from '@wundo/ui';
import type { ReviewSeverity } from '@/lib/conversationReviews.ts';

/* Worst first, so the chips read as a scale and the first one is the one to press. */
export const SEVERITY_ORDER: ReviewSeverity[] = [
  'critical',
  'high',
  'medium',
  'low',
  'ok',
];

export const SEVERITY_LABELS: Record<ReviewSeverity, string> = {
  critical: 'Critical',
  high: 'High',
  medium: 'Medium',
  low: 'Low',
  ok: 'Ok',
};

/*
 * Each rung takes the token that carries its meaning in this theme: danger, the
 * warning pair's ink, the brand navy of Badge's `info` tone, a faint grey for a limit
 * of the platform, and success green. Ink colours: a dot is too small for a wash.
 */
export const SEVERITY_MARK_CLASS: Record<ReviewSeverity, string> = {
  critical: 'bg-danger',
  high: 'bg-on-pink',
  medium: 'bg-primary',
  low: 'bg-ink-faint',
  ok: 'bg-success',
};

export const SEVERITY_TONES: Record<ReviewSeverity, BadgeTone> = {
  critical: 'danger',
  high: 'warning',
  medium: 'info',
  low: 'neutral',
  ok: 'success',
};
